import React, {useMemo, useState} from 'react'
import {ProgressBar} from "react-step-progress-bar";
import {useNavigate} from "react-router-dom";
import {useAuth} from "../../providers/AuthProvider";

const SupplierTalentWelcome = (props) => {

    const {auth, markTalentWelcomeAsViewed, shouldSeeTalentWelcome, appropriate} = useAuth();
    const [panel, setPanel] = useState(1);
    const progress = useMemo(() => auth?.profileProgress(), [auth]);
    const navigate = useNavigate();

    return (
        <div className={'talent-portal-page'}>
            <div className="nav-container">
                <div className="nav-info">

                    <div className="nav-welcome">
                        <p>Welcome</p>
                    </div>
                </div>
            </div>
            <div className="talent-portal-welcome">
                <div className="container mx-auto">
                    {panel === 1 && (
                        <div className="welcome-panel">
                            <div className="welcome-top text-center">
                                <h1>Hello {auth?.first_name}</h1>
                                <h1>Welcome to Wripple!</h1>
                                <p className="welcome-text px-3 xl:px-56 lg:px-44 mx-auto">Congratulations on being an approved talent member for your company{auth.supplier_client?.name && (
                                    <React.Fragment>, <span className="text-info">{auth.supplier_client?.name}</span></React.Fragment>
                                )}</p>

                                <img src="/images/talent-welcome/teamwork.png" className="w-full max-w-[450px] mx-auto -mt-6"/>
                            </div>

                            <div className="welcome-bottom pb-5 md:flex">
                                <div className="w-full text-center md:w-1/2">
                                    <p className="m-0 welcome-text">Now let's get to work.</p>
                                </div>
                                <div className="mt-4 w-full flex justify-center md:justify-end md:w-1/2 md:mt-0">
                                    <button className="btn btn-primary" onClick={() => setPanel(2)}>
                                        Next
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                    {panel === 2 && (
                        <div className="welcome-panel">

                            <div className="welcome-top">
                                <p className="welcome-text bold">Winning work starts with a great profile</p>

                                <div className="panel-progress mt-3">
                                    <p className="progress-title m-0">{`${progress}% of setup complete`}</p>
                                    <ProgressBar
                                        filledBackground={TB.config('color.light_green')}
                                        height={20}
                                        percent={progress}
                                        unfilledBackground={TB.config('color.gray')}
                                    />
                                </div>
                            </div>

                            <div className="winning-work-actions">
                                <div className="welcome-actions-section">
                                    <img src="/images/talent-welcome/teamwork-writing.png" className="img-fluid block mx-auto"/>

                                    <button
                                        className="btn btn-primary"
                                        onClick={async() => {
                                            await markTalentWelcomeAsViewed();
                                            return navigate({
                                                pathname: "/talent/application",
                                                // search: '?uploadResume=true'
                                            }, {replace: true})
                                        }}
                                    >
                                        Update Profile Now
                                    </button>
                                </div>

                                <div className="divider"/>

                                <div className="welcome-actions-section">
                                    <img src="/images/talent-welcome/dashboard-preview.png" className="img-fluid block mx-auto"/>

                                    <button className="btn btn-primary"
                                            onClick={async() => {
                                                await markTalentWelcomeAsViewed();
                                                return navigate('/talent/dashboard', {replace: true})
                                            }}>
                                        Skip to My Dashboard
                                    </button>
                                    <p className="actions-hint">I'll make profile updates later</p>
                                </div>
                            </div>

                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}
export default SupplierTalentWelcome;